


import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ErrorView extends Vue
{
	private code: string = '';
	private key: string  = '';

	private created()
	{
		// コード取得
		this.code = '[code:' + (this.$route.query.code as string) + ']';

		// メッセージ ID を取得
		const msgId: string = this.$route.query.msgId as string || '';

		// エラーメッセージが存在する場合のみ適用
		if ( this.$te('error.messages.' + msgId) )
		{
			this.key = msgId;
		}
	}
}
